<template>
  <div id="app">
    <app-nav />
    <router-view />
    <component
      v-if="currentModal"
      @close="$store.commit('clearCurrentModal')"
      :is="currentModal.type"
      :options="currentModal.options"
    />
    <div class="preload-font">.</div>
  </div>
</template>

<script>
import AppNav from "./components/Nav.vue";
import TestTypemismatchModal from "./components/Modals/TestTypeMismatch.vue";
import LoginModal from "./components/Modals/Login.vue";
import ForgotPasswordModal from "./components/Modals/ForgotPassword.vue";
import ResetPasswordModal from "./components/Modals/ResetPassword.vue";
import GeneralInfoModal from "./components/Modals/GeneralInfo.vue";
import RegisterModal from "./components/Modals/Register.vue";
import FurtherLocationsModal from "./components/Modals/FurtherLocations.vue";
import MapsDataPrivacyModal from "./components/Modals/MapsDataPrivacy.vue";
import OverwriteRequestModal from "./components/Modals/OverwriteRequest";
import RequestSentModal from "./components/Modals/RequestSent";
import InfoRoomsAndFacilitiesModal from "./components/Modals/InfoRoomsAndFacilities";
import InfoItAndTechnologyModal from "./components/Modals/InfoItAndTechnology";
import InfoProductStrorageAndPreparationModal from "./components/Modals/InfoProductStrorageAndPreparation";
import getEmptyUserRequestSetupData from "./modules/getEmptyUserRequestSetupData";
import ChangePasswordModal from "./components/Modals/ChangePassword";
import InfoTestType from "./components/Modals/InfoTestType";
import CustomLocationModal from "./components/Modals/CustomLocationModal.vue";
import PutTestStudioModal from "./components/Modals/PutTestStudioModal.vue";
import PutLocationModal from "./components/Modals/PutLocationModal.vue";
import TestStudioReviewsModal from "./components/Modals/TestStudioReviewsModal.vue";

export default {
  components: {
    AppNav,
    TestTypemismatchModal,
    LoginModal,
    ForgotPasswordModal,
    GeneralInfoModal,
    RegisterModal,
    FurtherLocationsModal,
    ResetPasswordModal,
    MapsDataPrivacyModal,
    OverwriteRequestModal,
    RequestSentModal,
    InfoRoomsAndFacilitiesModal,
    InfoItAndTechnologyModal,
    InfoProductStrorageAndPreparationModal,
    ChangePasswordModal,
    InfoTestType,
    CustomLocationModal,
    PutTestStudioModal,
    PutLocationModal,
    TestStudioReviewsModal,
  },
  created() {
    this.$store.dispatch("getBackendData", this.$http);
  },
  computed: {
    currentModal() {
      return this.$store.state.currentModal;
    },
    requestListTestType() {
      if (this.$store.state.user) {
        return this.$store.state.user.requestList.testType;
      } else {
        return null;
      }
    },
    requestListTestStudioIds() {
      if (this.$store.state.user) {
        return this.$store.state.user.requestList.testStudioIds;
      } else {
        return null;
      }
    },
    requestList() {
      if (this.$store.state.user) {
        return this.$store.state.user.requestList;
      } else {
        return null;
      }
    },
  },
  methods: {
    resetRequestInput(testStudioIds, testType) {
      if (this.$store.state.user) {
        this.$store.commit(
          "setRequestSetupObjects",
          getEmptyUserRequestSetupData(testStudioIds, testType)
        );
      }
    },
  },
  watch: {
    $route(to) {
      // hier und nicht in created, da auf keinen Fall der initiale automatische pageview geblockt werden soll
      window.gtag("config", "UA-159300631-2", {
        send_page_view: false,
      });
      window.gtag("config", "UA-159300631-2", { page_path: to.path });
    },
    requestList: {
      handler(newVal, oldVal) {
        // wenn alte requestList null ist => user hat sich gerade angemeldet --> kein reset, da evtl. vorhandene Daten geladen werden
        // newVal == null => user hat sich ausgeloggt --> kein reset, da kein user-Objekt
        if (oldVal == null || newVal == null) {
          return;
        }
        this.resetRequestInput(newVal.testStudioIds, newVal.testType);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
pre {
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
}
.modal-dialog .modal-content {
  padding: 0.7rem 0.7rem;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
  }
}
@media (min-width: 750px) {
  .modal-dialog {
    max-width: 605px;
  }
  .modal-dialog .modal-content {
    padding: 0.7rem 1.5rem;
  }
}
.preload-font {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  visibility: hidden;
  font-family: "Klavika";
  font-weight: normal;
}
.select-label {
  font-size: 1.05em;
  margin-top: -2em;
  margin-left: 0.5em;
  transition: all 0.15s;
}

.select-label.selected {
  font-size: 0.85em;
  margin-top: -3.5em;
  border-radius: 0.2em;
  color: #0000009a;
  background-color: white;
}

.select-label span {
  border-radius: 0.2em;
  color: #0000009a;
}
</style>
